export default __webpack_public_path__ + "static/media/CNo.47-1.0558019a.jpg";